import { render, staticRenderFns } from "./CoverImage.vue?vue&type=template&id=1c0ccdfe&scoped=true&"
import script from "./CoverImage.vue?vue&type=script&lang=js&"
export * from "./CoverImage.vue?vue&type=script&lang=js&"
import style0 from "./CoverImage.vue?vue&type=style&index=0&id=1c0ccdfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ccdfe",
  null
  
)

export default component.exports